export default "__VITE_ASSET__DO9NKsY6__"